var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNightlightRoundBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22c1.05 0 2.05-.16 3-.46-4.06-1.27-7-5.06-7-9.54 0-4.48 2.94-8.27 7-9.54-.95-.3-1.95-.46-3-.46-5.52 0-10 4.48-10 10s4.48 10 10 10z",
    fill: "#036"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgMjJDMTYuNTUgMjIgMTcuNTUgMjEuODQgMTguNSAyMS41NEMxNC40NCAyMC4yNyAxMS41IDE2LjQ4IDExLjUgMTJDMTEuNSA3LjUyIDE0LjQ0IDMuNzMgMTguNSAyLjQ2QzE3LjU1IDIuMTYgMTYuNTUgMiAxNS41IDJDOS45OCAyIDUuNSA2LjQ4IDUuNSAxMkM1LjUgMTcuNTIgOS45OCAyMiAxNS41IDIyWiIgZmlsbD0iIzAwMzM2NiIvPgo8L3N2Zz4K";
export { SvgNightlightRoundBlue as ReactComponent };